import {
  CardDefinition,
  CAROUSEL_TINDER,
  CarouselTinderDefinition,
  LAYOUT_LIST,
  LayoutListDefinition,
  QUIZ_CHOICE
} from '../items';
import { Translator } from '../Translator';
import { AnswerButtonHelper } from './itemHelpers/AnswerButtonHelpers';
import { CardTinderHelper } from './itemHelpers/CardTinderHelper';
import { TextHelper } from './itemHelpers/TextHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { useEditorStore } from '~/shell/Store';

export const Cards10: Translator = sequence => {
  const { editorMode } = useEditorStore.getState();

  const cards: CardDefinition[] = [];
  const header = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.list`,
    values: {
      orientation: 'column',
      align: 'center',
      padded: true
    },
    items: []
  } as LayoutListDefinition;

  const root = translate(sequence, item => {
    if (item.__typename === 'Question') {
      cards.push(
        CardTinderHelper(item as ItemOfType<'Question'>, {
          height: 'unset',
          width: '372px',
          align: 'left',
          padding: '0px',
          className: 'cardStyleForDarkTheme',
          items: item.items,
          linkedAudioId: item.audios?.[0]?.id,
          extraItems: [
            {
              id: `${item.id}.quiz`,
              type: QUIZ_CHOICE,
              values: {},
              items: AnswerButtonHelper({
                group: item.id,
                items: item.items,
                linkedAudioId: item.audios?.[0]?.id,
                llamaSurvey: item.llamaSurvey,
                question: item.title || ''
              })
            }
          ]
        })
      );
    }

    if (item.__typename === 'Text') {
      header.items = [
        {
          type: LAYOUT_LIST,
          id: `${sequence.id}.list`,
          values: {
            orientation: 'column',
            align: 'top',
            padded: false
          },
          items: TextHelper(item as ItemOfType<'Text'>)
        } as LayoutListDefinition
      ];
    }

    return null;
  });

  if (editorMode) {
    root.items.push({
      type: LAYOUT_LIST,
      id: `${sequence.id}.editorModeCardlist`,
      values: {
        align: 'center'
      },
      items: [
        header,
        {
          type: LAYOUT_LIST,
          id: `${sequence.id}.editorModeCardlistInner`,
          values: {
            padded: true,
            align: 'center',
            orientation: 'row',
            wrap: true
          },
          items: cards
        }
      ]
    } as LayoutListDefinition);
  } else {
    root.items.push(header, {
      type: CAROUSEL_TINDER,
      id: `${sequence.id}.carousel`,
      values: {
        variant: 'standard'
      },
      items: cards
    } as CarouselTinderDefinition);
  }

  return root;
};
